// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C8.41015 1 5.5 3.91015 5.5 7.5V9H3V23H21V9H18.5V7.5C18.5 3.91015 15.5899 1 12 1ZM16.5 7.5V9H7.5V7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5ZM7 12.5039H9.00391V15H7V12.5039ZM7 16.5H9.00391V19.0039H7V16.5Z"}}]};

const GitRepositoryPrivateFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'git-repository-private-filled',
    ref,
    icon: element,
  },
));

GitRepositoryPrivateFilledIcon.displayName = 'GitRepositoryPrivateFilledIcon';

export default GitRepositoryPrivateFilledIcon;
